const ja = {
  meta: {
    base: 'Blazblue Entropy Effect'
  },
  nav: {
    home: "ホーム",
    role: "キャラクター",
    video: "映像",
    announcement: "お知らせ",
  },
  role: {
    playerWarning: "あなたのブラウザはビデオタグをサポートしていません。ブラウザを変えてみてください。",
    rg: {
      name: "ラグナ",
      intro: "スキル発動時にHPを消費するが、それと引き換えに敵にダメージを与えるとHPが回復する。HPが低いほど、ダメージが高くなり、回復効果も強くなる。致命的な攻撃を避ければ、最大限に力を発揮できるようになる。"
    },
    a: {
      name: "Λ-No.11-",
      intro: "背後のブレードを操り、虚空からブレードを召喚して攻撃する。序盤では攻撃力が課題になるが、コアポテンシャルを解放すると、様々な場所からブレードを出現することができる。次々と現れるブレードを発射することで前方の敵を殲滅する。"
    },
    hk: {
      name: "ハクメン",
      intro: "移動速度が遅いが、高い攻撃力と防御力を持ち、カウンターが得意である。スキルを発動して敵の正面攻撃を防ぐと、破壊的な攻撃力を持つ技を発動できる。カウンターを極めることで、決して倒れない戦いをすることができる。"
    },
    hb: {
      name: "ヒビキ",
      intro: "あらゆる武器の使用や、影を操る攻撃などを得意とする。また、背後からの攻撃は与えるダメージが大幅に上昇する。その利点を最大限に生かすには、常に敵との位置関係を調整することがポイントとなる。"
    },
    nol: {
      name: "ノエル",
      intro: "2丁の銃で様々な打ち方ができる。銃の反動を利用し空中を柔軟に移動したり、攻撃することが可能。様々な攻撃スキルを組合せることで縦横無尽に戦闘を行えるようになる。"
    },
    kk: {
      name: "ココノエ",
      intro: "様々な武装で高速移動や爆撃、設置ができる。コアポテンシャルを開放させることで武装の使用後にトラップとして設置することができる。武装にも拡張性があり、多種多様な戦い方ができるようになる。"
    },
    ma: {
      name: "マイ",
      intro: "槍を使い、突進や投擲、更には竜巻を起こすことができる。ポテンシャルを成長させることで、突進の数を増やすことや多方向への投擲による画面制圧、竜巻での攻撃もより広範囲となる。移動する技が多く、危険な場所に入り込んでしまうため注意が必要。"
    },
    es: {
      name: "Es",
      intro: "俊敏な動きで大剣を振るい、紋章を出現させることで攻撃する。紋章にも攻撃判定があり、コアポテンシャルを成長させることで、より大きく綺麗になるため、フィールドでは華が咲くように戦う。"
    },
    tk: {
      name: "タオカカ",
      intro: "高い機動性と連続性を備えるキャラクター。縦横無尽な突進を得意とし、また回転しながら周りの敵を攻撃することができる。分身を作り出し、本体と一緒に攻撃することもできる。"
    },
    rc: {
      name: "レイチェル",
      intro: "彼女は従者である者たちを従え、攻撃を行う。また彼女自身が雷や風を起こすことで、戦いの中を優雅に舞うことができる。"
    },
    jn: {
      name: "ジン",
      intro: "敵を減速させ、凍結させることができる。関連するポテンシャルを開放させると、抜刀動作でブロッキングできるようになり、ブロッキングが成功するとさらに追加攻撃できる。また納刀した瞬間に技を発動すると、技が強化されるようになる。技をタイミングよく出せるほど強くなり、実力を最大限に発揮できる。"
    },
    hzm: {
      name: "ハザマ",
      intro: "主にナイフを使って接近戦を行い、鎖を使って自身と敵との距離を縮めたり、高速移動したりすることができる。ポテンシャルを獲得した後は、様々な攻撃で敵のMPを吸収することができる。"
    },
    // icey: {
    //     name: "ICEY",
    //     intro: "異界から来た少女。太刀を使い華麗な斬撃で敵を切り裂き、ダメージ後には強力な追撃で圧倒する。機械系の敵には追加ダメージを与え、その破壊力を発揮する。"
    // }
    bl: {
      name: "バレット",
      intro: "打撃と投げ技を得意とするキャラクター。さまざまな角度から敵を掴んで攻撃し、さらに砲撃による追撃を行う。ポテンシャルを獲得すると、強化状態になるとともに、遠距離から高速で突進して敵を掴んで攻撃を行うことができる。"
    }
  },
  news: {
    more: "詳細",
    slider: [
      {
        title: '',
        img: require("@/assets/images/news-slider3-ja.jpg"),
        content: ''
      },
      {
        title: 'クールでエキサイティングな体験！ローグライトアクション『ブレイブルー エントロピーエフェクト』早期アクセス版配信開始',
        img: require("@/assets/images/news-slider1-ja.jpg"),
        content: '<p>《『ブレイブルー エントロピーエフェクト』早期アクセス版配信開始！リリース価格2,300円のところ、配信開始記念として12％割引イベントを実施（配信日より７日間）。ACEの世界で逢いましょう！</p><p>『ブレイブルー エントロピーエフェクト』は格闘ゲーム『ブレイブルー』シリーズのスピンオフ作品として、91Actが開発する2D横スクロールタイプのローグライトアクションゲームです。</p><p>格闘ゲーム的なバトルの緊張感を味わえるローグライトアクション、高品質で組み上げた2Dバトル表現、キャラクターごとに独立したアクションデザイン、自分だけのキャラクターを生み出す「カスタマイゼーション」による育成システム等をお楽しみいただけます！</p><p>今すぐダウンロードし、爽快感満点の2Dバトルアクションを体験しましょう！</p><p>Steam Store Page:<a href="https://store.steampowered.com/app/2273430">https://store.steampowered.com/app/2273430</a></p><p>Twitter:<a href="https://twitter.com/BBEE_Global">https://twitter.com/BBEE_Global</a></p><p>YouTube:<a href="https://www.youtube.com/@BBEE_Global">https://www.youtube.com/@BBEE_Global</a></p><p>Discord:<a href="https://discord.gg/2s8sQbmtpE">https://discord.gg/2s8sQbmtpE</a></p>'
      },
      {
        title: '早期アクセス版リリースに関するよくある質問',
        img: require("@/assets/images/news-slider2-ja.jpg"),
        content: '<p>Q：早期アクセス版のリリースはいつですか？価額は？</br>A：『ブレイブルー エントロピーエフェクト』は8月16日午前11時よりSteamにてリリースいたします。リリース価額は2,300円で、早期アクセス版発売を記念して一週間割引イベントを実施する予定です。</p><p>Q：早期アクセス版はどのような内容が実装されていますか？</br>A：開発チームとして、より楽しくエキサイティングなゲーム体験をお届けるするため、下記のコンテンツを搭載しました。</br>■早期アクセス版内容</br>・４種のテーマで描く走破型ステージ＋ランダム生成によるメトロイドヴァニアスタイルの探索型マップ</br>・7人のスタイリッシュなキャラクター＋100種以上の選択可能な「ポテンシャル」</br>・8種類のエレメント体系＋200種以上のエレメント「戦術」</br>・固有の行動形態を持つ10体のボス＋異なる特徴を持つ50種類以上の敵</br>・高い攻略性を必要とし、高難易度な進化した敵とのバトルが待つ「上級トレーニングモード」</br>・心に響く表現によるストーリー展開</p><p>Q：今後のアップデート予定はどうでしょうか？</br>A：今年9月と11月に新プレイキャラ・新エピソード追加の無料DLCをアップデートし、2024年第1四半期に正式版をリリース予定です。</br>正式版はマルチエンディング・操作可能な新プレイキャラ・新たなプレイモードを実装します。</p><p>Q：『ブレイブルー エントロピーエフェクト』はどの言語に対応していますか？</br>A：早期アクセス版は、簡体字中国語、英語、日本語の表示に対応しています。さらに、中国語のフルボイスが実装されています。</p><p>Q：『ブレイブルー エントロピーエフェクト』のプレイに必要な最低スペックを教えてください。</br>A：WindowsとMacOSの両方に対応しています。<br/>最低要件：<br/>Windows：Intel Core i3/4GB RAM/GTX 950、またはそれ以上のスペック<br/>MacOS：Dual Core 2.4GHz/4GB RAM/Intel HD 5000、またはそれ以上のスペック"</p><p>QQ：ゲームの推奨表示解像度は？</br>A：2560 x 1440（2K）を推奨します。</p><p>Q：ゲームはコントローラーとSteam Deckに対応していますか？</br>A：ゲームはフルコントローラーサポートとなり、ゲーム内では「コントローラー操作」と「キーボード＋マウス操作」の切り替えができます。またキーコンフィグにて、自分に合った入力にすることも可能です。</br>※Steam Deck対応タイトルです。</p><p>Q：ゲームはマルチプレイに対応していますか？</br>A：早期アクセス版はシングルプレイとなります。</p><p>Q：公式情報のSNSや交流コミュニティを教えてください。</br>A：『ブレイブルー エントロピーエフェクト』Steamストアのフォロー、よろしくお願いいたします。</br>また、『ブレイブルー エントロピーエフェクト』は下記の公式SNSを運営しています。ぜひご参加ください。皆様との交流を心より期待しています。<br/><a href="https://twitter.com/BBEE_Global">公式Twitter：https://twitter.com/BBEE_Global</a> <a href="https://www.youtube.com/">公式YouTube: https://www.youtube.com/</a></br><a href="https://discord.gg/2s8sQbmtpE">@BBEE_Global 公式Discord：https://discord.gg/2s8sQbmtpE</a></p><p>Q：フィードバックの提案について、どのように公式スタッフに問い合わせますか？</br>A：上記の公式アカウントへのDMやディスコードサーバーを利用して、是非皆さまの貴重なご意見をください。</p>'
      },
    ],
    url: [
      {
        title: "『ブレイブルー エントロピーエフェクト』インタビュー。おすすめのキャラは？ マルチエンドのコンプリートまでにかかる時間は？【電撃インディー#470】",
        url: "https://dengekionline.com/articles/194537/"
      },
      {
        title: "ブレイブルーのアクションゲーム「BlazBlue Entropy Effect」プレイレポ－ト＆開発者インタビュー。シリーズファンに新たな体験を届けるスピンオフを目指す",
        url: "https://www.4gamer.net/games/684/G068440/20230719069/",
      },
      {
        title: "『ブレイブルー エントロピーエフェクト』プレイレポ。あの格闘ゲームのキャラたちがローグライトアクションに挑む【BitSummit Let’s Go!!】",
        url: "https://www.gamespark.jp/article/2023/07/14/132064.html",
      },
      {
        title: "『ブレイブルー エントロピーエフェクト』試遊版レビュー。キャラクターの能力を継承するカスタマイズ要素が奥深すぎる【BitSummit Let's Go!!】",
        url: "https://www.famitsu.com/news/202307/14309801.html",
      }
    ]
  },
  announcement: {
    title: "『BLAZBLUE ENTROPY EFFECT X』パッケージ版 「Day-1パッチ」に関する重要なお知らせ",
    subTitle: "",
    content: "<p>『BLAZBLUE ENTROPY EFFECT X』パッケージ版（PS5 / Switch）をご購入いただき、誠にありがとうございます。</p> <br /> <p>本作において、ゲーム内容の最適化および動作の安定性向上のため、発売日に「Day-1パッチ」の配信を致します。</p> <p>「Day-1パッチ」には、追加キャラクター「ナオト」や、新モード「極限エリア」の実装も含まれております。</p> <p>パッケージ版をご購入された方は、ゲーム開始前に必ずネットワークに接続し、「Day-1パッチ」を適用していただきますようお願い申し上げます。</p> <br /> <p><strong style=\"color: red;\">【セーブデータに関する重要なお知らせ】</strong></p> <p>「Day-1パッチ」が適用されていない状態で作成されたセーブデータを、「Day-1パッチ」適用後のバージョンで読み込むと、ストーリーモードが進行できない可能性があります。</p> <p>万が一この状況が発生した場合は、「Day-1パッチ」後のバージョンでセーブデータを新規作成し、最初からゲームをやり直していただきますようお願いいたします。</p> <br /> <p><strong style=\"color: red;\">【重要】</strong></p> <p>ご購入頂いた方へ、最高のゲーム体験をご提供させて頂きたく、プレイ前に必ず「Day-1パッチ」を適用ください。</p> <br /> <p>ご不便とご迷惑をおかけしますことを、深くお詫び申し上げます。</p> <p>ご理解とご協力のほど、何卒よろしくお願い申し上げます。</p>"
  }
}
export default ja
